import NetPositionsActions from "@redux/feature/PostLogin/actions/NetPositions";
import PortfolioCompositionActions from "@redux/feature/PostLogin/actions/PortfolioComposition";
import ContributionActions from "@redux/feature/PostLogin/actions/Contribution";
import IndexDetailsActions from "@redux/feature/PostLogin/actions/IndexDetails";
import MarketMapPLActions from "@redux/feature/PostLogin/actions/MarketMapPL";
import ServiceListActions from "@redux/feature/PostLogin/actions/ServiceList";
import DiversifyPortfolioActions from "@redux/feature/PostLogin/actions/DiversifyPortfolio";
import AllIndicesListActions from "@redux/feature/PostLogin/actions/AllIndicesList";
import UpcomingEventsActions from "@redux/feature/PostLogin/actions/UpcomingEvents";
export default (function () {
    return {
        postLogin: {
            positions: new NetPositionsActions(),
            portfolio: new PortfolioCompositionActions(),
            contribution: new ContributionActions(),
            indexDetails: new IndexDetailsActions(),
            marketMapPL: new MarketMapPLActions(),
            serviceList: new ServiceListActions(),
            diversifyPortfolio: new DiversifyPortfolioActions(),
            allIndicesList: new AllIndicesListActions(),
            upcomingEvents: new UpcomingEventsActions(),
        },
    };
});
